export default __webpack_public_path__ + "static/media/es.565198e2.svg";